module.exports = __webpack_public_path__ + "static/media/academy.117374cf.jpg";